export function cerealPolls(currentShow) {
    const currentTime = dayjs().tz("America/New_York").format("dddd, MMM D")
    const currentHour = dayjs().tz("America/New_York");
    console.log(currentTime);

}